import { AiRequestMetadataInput } from "@/modules/chats/services/ai/ch/__generated__/chChatCaseSummaryConfirmationMessageQuery.graphql"
import { chChatCaseSummaryConfirmationMessageQuery } from "@/modules/chats/services/ai/ch/chChatCaseSummaryConfirmationMessageQuery"
import { deChatCaseSummaryConfirmationMessageQuery } from "@/modules/chats/services/ai/de/deChatCaseSummaryConfirmationMessageQuery"
import { Country } from "@/types/__generated__/union-types"

export const chatCaseSummaryConfirmationMessageQuery = (
  country: Country,
  aiRequestMetadata: AiRequestMetadataInput,
) => {
  if (country === "DE") {
    return deChatCaseSummaryConfirmationMessageQuery(aiRequestMetadata)
  }
  return chChatCaseSummaryConfirmationMessageQuery(aiRequestMetadata)
}
